import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DashboardBackground = styled(Box)(({ theme }) => {
  const isDark = theme.palette.mode === 'dark';

  if (!isDark) {
    return {
      display: 'none',
    };
  }

  return {
    position: 'absolute',
    top: 0,
    left: 0,
    // width: '100vw',
    height: '100vh',
    pointerEvents: 'none',
    zIndex: -1,
    overflow: 'hidden',
    isolation: 'isolate',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      // zIndex: 1001,
    },
  };
});

export const BackgroundSvgWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '1978.944px',
  height: '1387.714px',
  transform: 'rotate(79.744deg) skewX(3.289deg)',
  top: '-70%',
  left: '50%',
  transformOrigin: 'center',
  marginTop: '-693.857px',
  marginLeft: '-989.472px',
  [theme.breakpoints.down('sm')]: {
    top: '-90%',
    left: '-20%',
    marginTop: '-500px',
    marginLeft: '-700px',
  },
  '& svg': {
    width: '100%',
    height: '100%',
    display: 'block',
  },
}));
